import cn from "app/utils/classnames";

interface ProgressBarProps {
  value: number;
  transitionClassName?: string;
}

export default function ProgressBar({
  value,
  transitionClassName = "",
}: ProgressBarProps) {
  const progress = value * 100;

  return (
    <div // BACKGROUND
      className={cn("w-full bg-background rounded-sm border border-black")}
    >
      <div // FILL
        className={cn(
          "h-4 rounded-sm",
          transitionClassName,
          getFillColor(progress)
        )}
        style={{ width: `${progress}%` }}
      ></div>
    </div>
  );
}

function getFillColor(progress: number): string {
  if (progress < 15) {
    return "bg-red-600";
  }
  if (progress < 40) {
    return "bg-yellow-500";
  }
  return "bg-black";
}
